import { Geofence } from '@/common/models/lift-dashboard/LiftAnalysisData';

export interface IResultPerUnitAPI {
  control_group_total: number;
  control_group_total_pre_campaign: number | null;
  control_group_visited: number;
  control_group_visited_pre_campaign: number | null;
  created_on_utc: string;
  exposed_to_ad_group_total: number;
  exposed_to_ad_group_total_pre_campaign: number | null;
  exposed_to_ad_group_visited: number;
  exposed_to_ad_group_visited_pre_campaign: number | null;
  id: number;
  liftanalysis_id: number;
  modified_on_utc: string;
  swarm_aws_region: string;
  unit: {
    created_on_utc: string;
    description: string;
    dwell_time: number;
    geofence: Geofence;
    geofence_id: number;
    hivestack_id: number;
    hivestack_organization_id: number;
    id: number;
    image_url: string;
    latitude: number;
    longitude: number;
    media_type: string;
    modified_on_utc: string;
    name: string;
    operating_hours: string;
    owner: {
      name: string;
      logoUrl: string;
    };
    swarm_aws_region: string;
    weekly_impressions: number;
  };
  unit_id: number;
}

export default class ResultsPerUnit {
  controlGroupTotal: number;

  controlGroupTotalPreCampaign: number | null;

  controlGroupVisited: number;

  controlGroupVisitedPreCampaign: number | null;

  createdOnUtc: string;

  exposedToAdGroupTotal: number;

  exposedToAdGroupTotalPreCampaign: number | null;

  exposedToAdGroupVisited: number;

  exposedToAdGroupVisitedPreCampaign: number | null;

  id: number;

  liftAnalysisId: number;

  modifiedOnUtc: string;

  swarmAwsRegion: string;

  unit: IResultPerUnitAPI['unit'];

  unitId: number;

  constructor(
    controlGroupTotal: number,
    controlGroupTotalPreCampaign: number | null,
    controlGroupVisited: number,
    controlGroupVisitedPreCampaign: number | null,
    createdOnUtc: string,
    exposedToAdGroupTotal: number,
    exposedToAdGroupTotalPreCampaign: number | null,
    exposedToAdGroupVisited: number,
    exposedToAdGroupVisitedPreCampaign: number | null,
    id: number,
    liftAnalysisId: number,
    modifiedOnUtc: string,
    swarmAwsRegion: string,
    unit: any,
    unitId: number,
  ) {
    this.controlGroupTotal = controlGroupTotal;
    this.controlGroupTotalPreCampaign = controlGroupTotalPreCampaign;
    this.controlGroupVisited = controlGroupVisited;
    this.controlGroupVisitedPreCampaign = controlGroupVisitedPreCampaign;
    this.createdOnUtc = createdOnUtc;
    this.exposedToAdGroupTotal = exposedToAdGroupTotal;
    this.exposedToAdGroupTotalPreCampaign = exposedToAdGroupTotalPreCampaign;
    this.exposedToAdGroupVisited = exposedToAdGroupVisited;
    this.exposedToAdGroupVisitedPreCampaign = exposedToAdGroupVisitedPreCampaign;
    this.id = id;
    this.liftAnalysisId = liftAnalysisId;
    this.modifiedOnUtc = modifiedOnUtc;
    this.swarmAwsRegion = swarmAwsRegion;
    this.unit = unit;
    this.unitId = unitId;
  }

  static fromApi(apiObject: IResultPerUnitAPI): ResultsPerUnit {
    return new ResultsPerUnit(
      apiObject.control_group_total,
      apiObject.control_group_total_pre_campaign,
      apiObject.control_group_visited,
      apiObject.control_group_visited_pre_campaign,
      apiObject.created_on_utc,
      apiObject.exposed_to_ad_group_total,
      apiObject.exposed_to_ad_group_total_pre_campaign,
      apiObject.exposed_to_ad_group_visited,
      apiObject.exposed_to_ad_group_visited_pre_campaign,
      apiObject.id,
      apiObject.liftanalysis_id,
      apiObject.modified_on_utc,
      apiObject.swarm_aws_region,
      apiObject.unit,
      apiObject.unit_id,
    );
  }

  toApi(): IResultPerUnitAPI {
    return {
      control_group_total: this.controlGroupTotal,
      control_group_total_pre_campaign: this.controlGroupTotalPreCampaign,
      control_group_visited: this.controlGroupVisited,
      control_group_visited_pre_campaign: this.controlGroupVisitedPreCampaign,
      created_on_utc: this.createdOnUtc,
      exposed_to_ad_group_total: this.exposedToAdGroupTotal,
      exposed_to_ad_group_total_pre_campaign: this.exposedToAdGroupTotalPreCampaign,
      exposed_to_ad_group_visited: this.exposedToAdGroupVisited,
      exposed_to_ad_group_visited_pre_campaign: this.exposedToAdGroupVisitedPreCampaign,
      id: this.id,
      liftanalysis_id: this.liftAnalysisId,
      modified_on_utc: this.modifiedOnUtc,
      swarm_aws_region: this.swarmAwsRegion,
      unit: this.unit,
      unit_id: this.unitId,
    };
  }
}
